import { render } from "./Pages.vue?vue&type=template&id=2e45aa5e&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=2e45aa5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2e45aa5e"

export default script